import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Report from '../components/Report'
import UpperHeader from '../components/UpperHeader'
import { useAlert } from "react-alert";

export default function Declaranet() {
    let alert = useAlert();
    const [files, setFiles] = React.useState([]);
    const [value, setValue] = React.useState('');

    React.useEffect(() => {
        getDeclaration()
    }, [])

    const getDeclaration = () => {
        fetch(
            `${process.env.REACT_APP_URL_API}/data/getDeclaration`,
            {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache",
                    "Access-Control-Allow-Origin": "*",
                },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                setValue(data[0].declaration.content);
                setFiles(data[0].files);
            })
            .catch((error) => {
                alert.show("Ocurrió un error al obtener las datos de las Declaraciones", {
                    timeout: 3000,
                    type: "error",
                });
            });
    }

    return (
        <div>
            <UpperHeader child={false} />
            <Header />
            <Report />
            <div className="text-center p-2 pt-3">
                <p className='colorblue'>
                    <h2 className='fw-bold fst-italic'>
                        Declaranet OIC
                    </h2>
                </p>
            </div>
            <img src="linea-de-color.jpg" alt='Linea Color' className='img-fluidLine reverse' style={{ marginBottom: "22px" }} />
            <div className="container">
                <div className="row">
                    <div className="col-6 text-center">
                        <a className='btn btn-success' target='_blank' rel='noreferrer' href="https://declaranetoic.mpiochih.gob.mx:4443/">Declaranet</a>
                    </div>
                    <div className="col-6 text-center">
                        <a className='btn btn-success' target='_blank' rel='noreferrer' href="http://consultadeclaranetoic.mpiochih.gob.mx/ ">Consulta</a>
                    </div>
                </div>
            </div>
            <pre>
                {value && <>
                    <div className="container" style={{ overflow: "hidden" }}>
                        <span className="view ql-editor" style={{ fontSize: "1rem" }} dangerouslySetInnerHTML={{ __html: value }} />
                    </div>
                </>}
            </pre>
            <div className="text-center">
                {files && files.map((val, i) => {
                    return <div key={i} className="boardContainer">
                        <a href={val.routeimage} className='noLink' style={{ color: "black" }} rel="noreferrer" target='_blank' download>
                            <div className="singleboardContainer bodyBackLogo text-center">
                                <img src={`${val.route.split(".")[1]}icon.png`} alt="Icono Descarga" style={{ height: 50, width: 45 }} />
                                <br /><br />
                                <p>{val.route.substr(5, 100)}</p>
                            </div>
                        </a>
                    </div>
                })}
            </div>
            <Footer showmap={false} />
        </div>
    )
}
